export const STATUS_SUCCESS = 0x00000000;
export const STATUS_FAILURE_NOT_AUTHORIZED = 0x00000101;
export const STATUS_FAILURE_ILLEGAL_REQUEST = 0x00000102;
export const STATUS_FAILURE_NOT_AUTHORIZED_DEMO = 0x00000103;
export const STATUS_FAILURE_NO_TARGET = 0x00000104;
export const STATUS_FAILURE_NO_OPTION = 0x00000105;
export const STATUS_FAILURE_STATUS = 0x00000108;
export const STATUS_ERROR_INTERNAL = 0x00000201;

export const STATUS_FAILURE_TOP_EXISTSOWNER = 0x00000301;
export const STATUS_FAILURE_TOP_REGISTERDONE = 0x00000302;
export const STATUS_FAILURE_OWNER_NOTEXISTS = 0x00000311;
export const STATUS_FAILURE_USER_INPUTREQUIRED = 0x00000321;
export const STATUS_FAILURE_USER_DUPLICATE_SYSID = 0x00000322;
export const STATUS_FAILURE_USER_DUPLICATE_MSKEY = 0x00000323;
export const STATUS_FAILURE_COUNT_SMS = 0x00000331;
export const STATUS_FAILURE_COUNT_MAIL = 0x00000332;
export const STATUS_FAILURE_USER_COOP_NOUSER = 0x00000324;
export const STATUS_FAILURE_USER_COOP_NETWORK = 0x00000325;

export const MAIL_KEY = btoa('__owner_mail__');
export const PASS_KEY = btoa('__owner_password__');

export const API_BASE = `${location.protocol}//${location.host}/ajax`;

export const UI_USE = 0;
export const UI_REQUIRED = 1;
export const UI_EXT1 = 2;
export const UI_EXT2 = 3;